import React from 'react';
import NewsSection from './news-events/NewsSection';
import EventsSection from './news-events/EventsSection';
import { LAYOUT } from '../styles/constants';

const NewsEvents = () => {
  return (
    <div className="relative w-full">
      {/* Background container that extends across both sections */}
      <div className="absolute w-full bg-[#D9D9D9]" style={{
        top: 0, // Start from the top to include ribbons
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0
      }} />
      
      {/* Content container */}
      <div 
        className="relative z-10 mx-auto px-4"
        style={{ maxWidth: LAYOUT.NEWS_EVENTS.CONTAINER.WIDTH }}
      >
        <div className="flex flex-col lg:flex-row gap-8">
          <NewsSection />
          <EventsSection />
        </div>
      </div>
    </div>
  );
};

export default NewsEvents;